import { Injectable } from '@angular/core';
import { adaptSearchAreas } from '../../lib/apis/search-area/adapt-search-areas';
import { SearchAreaApi } from '../../lib/apis/search-area/search-area.api';
import { SearchAreas } from '../../models/search-area/search-areas';
import { firstValueFrom } from '../../utils/first-value-from';

@Injectable({ providedIn: 'root' })
export class SearchAreaRepository {
  constructor(private readonly api: SearchAreaApi) {}

  async getAllBySearchAreaGroup(
    searchAreaGroupId: string,
  ): Promise<SearchAreas> {
    const res = await firstValueFrom(
      this.api.getAllBySearchAreaGroup(searchAreaGroupId),
    );
    return adaptSearchAreas(res);
  }
}
